import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationHelperService {

  public formatExistingDoors(doorNames: string[]): string {
    if (!doorNames.length) return 'None';
    return doorNames.join(', ');
  }
}
